/**
 * Creates a First In, First Out (FIFO) data structure list
 */
export class Queue<Item> {
  items: Item[];
  constructor(initialItems?: Item[]) {
    this.items = initialItems || [];
  }

  /** Add to end of the line */
  add(item: Item): void {
    this.items.push(item);
  }

  /** Get first in line */
  next(): Item | undefined {
    return this.items.shift();
  }

  peekAtNext(): Item | undefined {
    return this.items[0];
  }

  clear(): void {
    this.items = [];
  }

  get length(): number {
    return this.items.length;
  }

  isEmpty(): boolean {
    return this.items.length === 0;
  }
}
